import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { CreateExternalTeacherBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const createExternalTeacher = createAsyncThunk<string, CreateExternalTeacherBody, { extra: Partial<Dependencies> }>(
  "educationalAdvisor/externalTeacher/create",
  async (body, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.createExternalTeacher(body);
  },
);

export const resetCreateExternalTeacher = createAction("educationalAdvisor/externalTeacher/resetCreate");
